import * as React from 'react';
import { IFileHoverCardProps } from './FileHoverCard';
import { IComponentDecorator, IDecoratedComponentType, IDecoratedProps } from '../../utilities/components/Decorators';
import { IDecorateWithCurrentItemProps } from '../decorators/selectors';
import { afterPageLoad } from '../decorators/afterPageLoad';
import { asAsync } from '../../utilities/components/Async';
import * as HoverZoneStyles from './HoverZone.scss';

const FileHoverCard = afterPageLoad()(asAsync(async () => (
  await import(/* webpackChunkName: 'itemsviewdeferred' */'../DeferredComponents')
).FileHoverCard));
const CurrentFileHoverCard = afterPageLoad()(asAsync(async () => (
  await import(/* webpackChunkName: 'itemsviewdeferred' */'../DeferredComponents')
).CurrentFileHoverCard));

export interface IHasTargetProps {
  target?: HTMLElement | undefined;
}

export type IDecorateAsHoverZoneProps<P> = IDecoratedProps<P, IHasTargetProps, {}>;

function asHoverZone(): IComponentDecorator<IHasTargetProps, {}> {
  return <P extends IHasTargetProps>(
    component: React.ComponentType<P>
  ): IDecoratedComponentType<P, IHasTargetProps, {}> => {
    const Component = component;

    type IProps = IDecoratedProps<P, IHasTargetProps, {}>;

    interface IHoverZoneState {
      target: HTMLElement | null;
    }

    class HoverZone extends React.PureComponent<IProps, IHoverZoneState> {
      constructor(props: IProps) {
        super(props);

        this.state = {
          target: null
        };
      }

      public render(): JSX.Element {
        return (
          <div className={ HoverZoneStyles.target } ref={ this._setTarget }>
            { this.props.children }
            {
              this.state.target &&
              (
                <div className={ HoverZoneStyles.host }>
                  <Component
                    target={ this.state.target }
                    { ...this.props }
                  />
                </div>
              )
            }
          </div>
        );
      }

      private _setTarget = (element: HTMLElement | null): void => {
        this.setState({
          target: element
        });
      }
    }

    return HoverZone;
  };
}

export type IFileHoverCardZoneProps = IDecorateAsHoverZoneProps<IFileHoverCardProps>;

export const FileHoverCardZone: React.ComponentType<IFileHoverCardZoneProps> = asHoverZone()(FileHoverCard);

export type ICurrentFileHoverCardZoneProps = IDecorateWithCurrentItemProps<IFileHoverCardZoneProps>;

export const CurrentFileHoverCardZone: React.ComponentType<ICurrentFileHoverCardZoneProps> = asHoverZone()(CurrentFileHoverCard);
